module.exports = __webpack_public_path__ + "media/images/img/tag_company/ogis_tag-d37e6c1053495799d4ba728443da81b8.png";